var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 20,
    viewBox: "0 0 65 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4743 0.433594H26.3132L23.0898 19.3466H28.2424L31.4743 0.433594Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1124 19.3264L24.2295 0.445312H18.7672L13.7177 13.3452L13.1788 11.3975C12.189 9.05436 9.36009 5.68189 6.03906 3.55886L10.6548 19.3328L16.1124 19.3264Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1949 13.1633C46.2141 11.0161 44.8351 9.37829 41.8637 8.02553C40.0578 7.1518 38.9571 6.56917 38.9703 5.68254C38.9703 4.89923 39.9024 4.05782 41.9221 4.05782C43.612 4.03188 44.8288 4.40079 45.7805 4.78274L46.2468 4.99646L46.9462 0.899209C45.9232 0.517115 44.324 0.109375 42.3239 0.109375C37.2289 0.109375 33.6425 2.67275 33.6101 6.34922C33.5776 9.06792 36.174 10.5825 38.1289 11.4886C40.1356 12.4121 40.8089 13.0032 40.796 13.8317C40.7831 15.0985 39.1968 15.6762 37.7144 15.6762C35.6493 15.6762 34.5551 15.3915 32.8582 14.6847L32.1988 14.3819L31.4745 18.62C32.6778 19.1458 34.9045 19.6054 37.216 19.6245C42.6342 19.6245 46.1561 17.0938 46.1949 13.1633Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3257 16.5135C52.9148 16.5135 58.1779 16.52 58.9292 16.52C59.0846 17.1786 59.5572 19.3549 59.5572 19.3549H64.3412L60.1655 0.454834H56.1842C54.9476 0.454834 54.0287 0.791431 53.4846 2.02103L45.8263 19.3549H51.2452C51.2447 19.3549 52.125 17.0251 52.3257 16.5135ZM55.8602 7.35454C55.8347 7.40627 56.2877 6.26071 56.5467 5.54869L56.8961 7.17965C56.8961 7.17965 57.8804 11.6978 58.0874 12.6428H53.8081C54.2355 11.5555 55.8602 7.35454 55.8602 7.35454Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9645 10.1586L11.2223 1.80226C10.9245 0.649898 10.0578 0.307071 8.97497 0.261719H0.987172L0.916016 0.643524C7.13736 2.15147 11.2539 5.78925 12.9645 10.1586Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.9c3191869e1ecd5f6a5bf5fd48d7eb68.svg";
export { ForwardRef as ReactComponent };